var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcHeaderProBadge = function SvgIcHeaderProBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.652.336a.5.5 0 0 1 .696 0l1.454 1.407a.5.5 0 0 0 .418.136l2.003-.283a.5.5 0 0 1 .563.408l.35 1.993a.5.5 0 0 0 .258.356l1.787.948a.5.5 0 0 1 .215.661l-.889 1.818a.5.5 0 0 0 0 .44l.889 1.818a.5.5 0 0 1-.215.66l-1.787.95a.5.5 0 0 0-.258.355l-.35 1.993a.5.5 0 0 1-.563.408l-2.003-.283a.5.5 0 0 0-.418.136l-1.454 1.407a.5.5 0 0 1-.696 0l-1.454-1.407a.5.5 0 0 0-.418-.136l-2.003.283a.5.5 0 0 1-.563-.408l-.35-1.993a.5.5 0 0 0-.258-.356L.82 10.7a.5.5 0 0 1-.215-.661l.889-1.818a.5.5 0 0 0 0-.44L.604 5.962a.5.5 0 0 1 .215-.66l1.787-.95a.5.5 0 0 0 .259-.355l.35-1.993a.5.5 0 0 1 .562-.408l2.003.283a.5.5 0 0 0 .418-.136L7.652.336Z",
    fill: "url(#ic_header_pro_badge_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.269 11V4.659h2.615c1.336 0 2.228.861 2.228 2.166v.009C11.112 8.139 10.22 9 8.884 9H7.596v2H6.27Zm2.29-5.291h-.963v2.254h.963c.76 0 1.208-.404 1.208-1.125V6.83c0-.721-.448-1.121-1.208-1.121Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_header_pro_badge_svg__a",
    x1: -0.885,
    y1: 0,
    x2: 16.885,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397EE6"
  })))));
};
export default SvgIcHeaderProBadge;